// @ts-nocheck
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Prefer dedicated RLevents env vars; fall back to the main Supabase env so that
// module initialization never throws in builds where the RLevents vars are missing
// (e.g. production). Code that actually uses this client should guard against the
// fallback scenario via VITE_RLEVENTS_SUPABASE_URL being set.
const RLEVENTS_SUPABASE_URL =
  import.meta.env.VITE_RLEVENTS_SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL ||
  '';
const RLEVENTS_SUPABASE_ANON_KEY =
  import.meta.env.VITE_RLEVENTS_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  '';

export const rleventsConfigured = Boolean(
  import.meta.env.VITE_RLEVENTS_SUPABASE_URL &&
    import.meta.env.VITE_RLEVENTS_SUPABASE_ANON_KEY,
);

// Import the rlevents supabase client like this:
// import { rleventsSupabase } from "@/integrations/rlevents/client";

export const rleventsSupabase = createClient<Database>(
  RLEVENTS_SUPABASE_URL,
  RLEVENTS_SUPABASE_ANON_KEY,
  {
    auth: {
      storageKey: 'rlevents-auth',
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
